import { useI18n } from "vue-i18n";
/**
 * Shared plumbing for duplicate-detection result-card accessible names. Currently consumed only
 * by contact's `useContactDedupAccessibleName`; reception's `useCandidateAccessibleName` still
 * carries its own copy of this join and organisation's equivalent lands on OP-7164 — both are
 * expected to migrate here. Every module has its own i18n namespace and its own disambiguating
 * identity fragment (birth date vs address/city, formatted differently), so this composable owns
 * only the shape that drifts across copies: build `<action> <name>[, <detail>]`, dropping the
 * detail cleanly when absent so the accessible name never trails a dangling separator.
 */
export function useDedupAccessibleName() {
    const { t } = useI18n();
    function dedupResultAccessibleName(actionKey, name, detail, buildIdentity) {
        const identity = detail ? buildIdentity(name, detail) : name;
        return t(actionKey, { name: identity });
    }
    return { dedupResultAccessibleName };
}
